import { query } from '@confluence/query-preloader-tools';

import { ReadTimeQuery } from './ReadTimeQuery.graphql';
import type {
	ReadTimeQuery as ReadTimeQueryType,
	ReadTimeQueryVariables,
} from './__types__/ReadTimeQuery';

type PreloadReadTimeParams = {
	contentId: ReadTimeQueryVariables['contentId'];
	useCache: boolean;
	status?: ReadTimeQueryVariables['status'];
};

export function preloadReadTime({ contentId, useCache, status }: PreloadReadTimeParams) {
	return query<ReadTimeQueryType, ReadTimeQueryVariables>({
		query: ReadTimeQuery,
		variables: {
			contentId,
			status,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
